/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingFurnitureTileModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +caption?: ?string,
    +cta?: ?string,
    +imagePath?: ?string,
    +link?: ?string,
  |}>,
  +$refType: ContemporaryLandingFurnitureTileModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingFurnitureTileSection",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "caption",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cta",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imagePath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "link",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8b73ecf1f6a0bc9eba704de97f904300';
module.exports = node;
